import React, { useState } from "react";
import { Modal, Button, Input, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { getApiUrl } from "../../../../config/applicationConfig";
import { GetCentralByAnalysisFavorite } from "../../../../redux/actions/Analysis/AnalysisActions";
import { useTranslation } from "react-i18next";

const CentralPageTreeAddFavorite = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [name, setName] = useState("");
  const analysisSelectedTagState = useSelector((p) => p.AnalysisReducer);

  const showModal = () => {
    if (analysisSelectedTagState.selectedTags?.length > 0) {
      setIsModalVisible(true);
    } else {
      message.error(t("selectTemplate"));
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleOk = () => {
    if (name.length > 0) {
      InsertAnalysisFavorite(analysisSelectedTagState.selectedTags, name);
    } else {
      message.error(t("enterTemplateTitle"));
    }
  };

  const InsertAnalysisFavorite = (selectedTags, name) => {
    const data = {
      treeviewIds: selectedTags.filter((p) => p.type == 2).map((p) => p.id),
      userId: 0,
      name: name,
    };
    axios
      .post(getApiUrl("/api/CentralByAnalysisFavorite/Insert"), data)
      .then((res) => res.data)
      .then((res) => {
        message.success(res.message);
        dispatch(GetCentralByAnalysisFavorite());
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsModalVisible(false);
        setName("");
      });
  };

  return (
    <>
      <Button
        style={{ width: "100%", backgroundColor: "#cacaca" }}
        size="small"
        disabled={analysisSelectedTagState.selectedTags?.length <= 0}
        onClick={showModal}
      >
        Seçimi Kaydet
      </Button>
      <Modal
        title={t("addSelectionToFavorites")}
        visible={isModalVisible}
        width={500}
        cancelText={t("cancel")}
        onCancel={handleCancel}
        okText={t("save")}
        onOk={handleOk}
      >
        <Input
          placeholder={t("favoriName")}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </Modal>
    </>
  );
};
export default CentralPageTreeAddFavorite;
